import React from 'react';
// hoc
import withSizes from 'react-sizes';
// shapes
import stressChartShape from '../../../shapes/stressChart';
// utils
import get from 'lodash.get';
// styles
import styles from './StressTable.mod.css';
import classnames from 'classnames/bind';
import RecoverySection from './RecoverySection';
import isEmpty from 'lodash.isempty';

let cx = classnames.bind(styles);

const StressTable = ({ isMobile, isDesktop, stress, placeholder }) => {
  const titles = ['Low', 'Moderate', 'High'];
  const colors = ['#7fe7ab', '#ffc132', '#e05e65'];
  const progress = get(stress, 'content_progress.question_progresses', null);

  if (isDesktop) {
    return (
      <RecoverySection title="Stress chart" placeholder={`${placeholder} 6`}>
        {!isEmpty(stress) && (
          <div className={cx('wrapper')}>
            <div className={cx('container')}>
              <div className={cx('row')}>
                <div className={cx('title-cell')} />
                {titles.map((title, index) => (
                  <div
                    className={cx('cell')}
                    key={index}
                    style={{ color: colors[index] }}
                  >
                    {title}
                  </div>
                ))}
              </div>
              {progress.map(({ question, question_answer_progresses }) => (
                <div key={question.id} className={cx('row')}>
                  <div key={question.id} className={cx('title-cell')}>
                    {question.title}
                  </div>
                  {question_answer_progresses.map(({ value }, index) => (
                    <p key={index} className={cx('value')}>
                      {value}
                    </p>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}
      </RecoverySection>
    );
  }

  if (isMobile) {
    return (
      <RecoverySection title="Stress chart" placeholder={`${placeholder} 6`}>
        {!isEmpty(stress) && (
          <div className={cx('mob-container')}>
            {progress.map(({ question, question_answer_progresses }, index) => (
              <div key={question.id} className={cx('column')}>
                <div
                  className={cx('title-cell')}
                  style={{ color: colors[index] }}
                >
                  {question.title}
                </div>
                {titles.map((title, index) => (
                  <label key={index} className={cx('mob-row')}>
                    <span className={cx('answer')}>{title}</span>
                    <span className={cx('value')}>
                      {question_answer_progresses[index].value}
                    </span>
                  </label>
                ))}
              </div>
            ))}
          </div>
        )}
      </RecoverySection>
    );
  }
};

StressTable.propTypes = stressChartShape;

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
  isDesktop: width >= 768
});

export default withSizes(mapSizesToProps)(StressTable);



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/components/StressTable.jsx